import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from '../../gameData.js';

export default class Vial extends AContainer
{
    constructor(scene, x, y, ind, color, amount)
    {
        super(scene);

        this.color = color;
        this.startX = x;
        this.startY = y;
        this.ind = ind;
        this.amount = amount;
        this.isCustom = false;

        this.topVials = [];
        this.bottomVials = [];
        this.vials = [];

        this.createVial();
        //this.tweenInVials();
    }

    createVial()
    {
        //console.log(this.amount, this.ind);
        let bottomVial = this.scene.addContainer(this.startX, this.startY).setDepth(1);
        let topVial = this.scene.addContainer(this.startX, this.startY).setDepth(3);

        let bottom = this.scene.addImage(0, 0, "Vial", this.scene.defaultAtlas, bottomVial);
        let top = this.scene.addImage(0, 0, "Vial", this.scene.defaultAtlas, topVial);
        this.band = this.scene.addImage(0, -170, "Vial_" + this.color.name, this.scene.defaultAtlas, topVial);
        
        top.setAlpha(.375);

        this.name = this.color.name;
        this.startColor = this.color.color;
        this.color = this.color.color;
        this.yAdj = bottom.height*1.5 - 18;
        this.bugCount = 0;
        this.bunchedX = 125 + (this.ind*90);
        this.unbunchedX = this.scene.mid.y - 25;

        this.bottomVials.push(bottomVial);
        this.topVials.push(topVial);
        this.vials.push([topVial, bottomVial]);
    }

    setCustom()
    {
        //console.log(this.name, gameData.fuzzStencil_Name, gameData.fuzzColor_Name, gameData.fuzzStencil_Color);
        this.isCustom = true;
        this.name = "Custom";
        gameData.customReplacementColor = this.name;
        gameData.customReplacementID = this.ind;

        this.band.destroy();
        this.band = this.scene.addImage(0, -170, "Vial_" + gameData.fuzzColor_Name, this.scene.defaultAtlas, this.topVials[0]);

        let pattern = this.scene.addImage(0, -170, "Vial_" + gameData.fuzzStencil_Name, this.scene.defaultAtlas, this.topVials[0]);
        let color = "0x"+gameData.fuzzStencil_Color.toString();
        pattern.setTint(color);
    }

    cleanUp()
    {
        //console.log("cleaning UP");
        this.bottomVials.forEach((vial)=>{vial.destroy();});
        this.topVials.forEach((vial)=>{vial.destroy();});
       
        this.name = null;
        this.startColor = null;
        this.color = null;

        this.bottomVials = [];
        this.topVials = [];
        this.vials = [];
    }
}